import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  addBank,
  createConnectedAccount,
  createTransfer,
  getBanks,
  getFundraiserCategories,
  getFundraisersBySubCategoryId,
  getFundsDeposited,
  getOnboardingStatus,
  getWithdrawals,
  getAccountDetails,
  updateReferredBy,
  getFundraisers,
  getFundraiserInquiries,
  addContent,
  getFundraiserContent,
  toggleFundraiserStatus,
  getSubCategoriesByCategoryId,
  referMerchant,
  getFundraiserReferrals,
  getDashboardStats,
  getTransactions,
  getMerchantById,
  getTarget,
  createTarget,
  updateTarget,
  getFundraiserById,
  bulkStatusUpdate,
  getAllTargets,
  getAllMerchants,
  getIncludedMerchants,
  getExcludedMerchants,
  updateMerchantVisibility,
} from "../../services/fundraiserService";
import toast from "../../utils/toast";

const initialState = {
  allFundraisers: null,
  fundraiserCategories: null,
  subCategories: null,
  fundraisers: null,
  fundsDeposited: null,
  bankAdded: null,
  banks: null,
  withdrawals: null,
  transfer: null,
  payoutLink: null,
  onboardingStatus: null,
  accountDetails: null,
  referBy: null,
  inquiries: null,
  contentAdded: null,
  fundraiserContent: null,
  toggleFundraiser: null,
  referredMerchant: null,
  referrals: null,
  dashboardStats: null,
  transactions: null,
  merchantById: null,
  targetCreated: null,
  target: null,
  targetUpdated: null,
  fundraiserById: null,
  statusUpdated: null,
  allTargets: null,
  loading: false,
};

const fundraiserSlice = createSlice({
  name: "fundraiser",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFundraiserCategories?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.fundraiserCategories = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(
      getSubCategoriesByCategoryId?.fulfilled,
      (state, action) => {
        if (action?.payload?.success === true) {
          state.subCategories = action.payload.data;
        } else {
          toast.error(action?.payload?.message);
        }
        state.loading = false;
      }
    );

    builder.addCase(
      getFundraisersBySubCategoryId?.fulfilled,
      (state, action) => {
        if (action?.payload?.success === true) {
          state.fundraisers = action.payload.data;
        } else {
          toast.error(action?.payload?.message);
        }
        state.loading = false;
      }
    );

    builder.addCase(getFundsDeposited?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.fundsDeposited = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(addBank?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.bankAdded = action?.payload?.data;
      } else {
        // toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getBanks?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.banks = action.payload.data;
      } else {
        // toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getWithdrawals?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.withdrawals = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(createTransfer?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.transfer = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(createConnectedAccount?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.payoutLink = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getOnboardingStatus?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.onboardingStatus = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getAccountDetails?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.accountDetails = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(updateReferredBy?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.referBy = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getFundraisers?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.allFundraisers = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getFundraiserInquiries?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.inquiries = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(addContent?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.contentAdded = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getFundraiserContent?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.fundraiserContent = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(toggleFundraiserStatus?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.toggleFundraiser = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(referMerchant?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.referredMerchant = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getFundraiserReferrals?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.referrals = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getDashboardStats?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.dashboardStats = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getTransactions?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.transactions = action.payload;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getMerchantById?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.merchantById = action?.payload?.data;
        toast.success(action?.payload?.data, {
          style: {
            background: "#E6F7FB",
            color: "#007EA7",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            padding: "12px 16px",
          },
          progressStyle: {
            background: "#007EA7",
          },
          icon: "✅",
        });
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getTarget?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.target = action.payload.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(createTarget?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.targetCreated = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(updateTarget?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.targetUpdated = action?.payload?.data;
      } else {
        toast.error(action?.payload?.message);
      }
      state.loading = false;
    });

    builder.addCase(getFundraiserById?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.fundraiserById = action?.payload?.data;
        toast.success(action?.payload?.data, {
          style: {
            background: "#E6F7FB",
            color: "#007EA7",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            padding: "12px 16px",
          },
          progressStyle: {
            background: "#007EA7",
          },
          icon: "✅",
        });
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(bulkStatusUpdate?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.statusUpdated = action?.payload?.data;
        toast.success(action?.payload?.message, {
          style: {
            background: "#E6F7FB",
            color: "#007EA7",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            padding: "12px 16px",
          },
          progressStyle: {
            background: "#007EA7",
          },
          icon: "✅",
        });
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder.addCase(getAllTargets?.fulfilled, (state, action) => {
      if (action?.payload?.success === true) {
        state.loading = false;
        state.allTargets = action?.payload?.data;
        // toast.success(action?.payload?.message);
      } else {
        state.loading = false;
        toast.error(action?.payload?.message);
      }
    });

    builder
      .addMatcher(
        isAnyOf(
          addBank?.pending,
          createConnectedAccount?.pending,
          createTransfer?.pending,
          getBanks?.pending,
          getFundraiserCategories?.pending,
          getFundraisersBySubCategoryId?.pending,
          getFundsDeposited?.pending,
          getOnboardingStatus?.pending,
          getWithdrawals?.pending,
          getAccountDetails?.pending,
          updateReferredBy?.pending,
          getFundraisers?.pending,
          getFundraiserInquiries?.pending,
          addContent?.pending,
          getFundraiserContent?.pending,
          toggleFundraiserStatus?.pending,
          getSubCategoriesByCategoryId?.pending,
          referMerchant?.pending,
          getFundraiserReferrals?.pending,
          getDashboardStats?.pending,
          getTransactions?.pending,
          getMerchantById?.pending,
          getTarget?.pending,
          createTarget?.pending,
          updateTarget?.pending,
          getFundraiserById?.pending,
          bulkStatusUpdate?.pending,
          getAllTargets?.pending,
          getAllMerchants?.pending,
          getIncludedMerchants?.pending,
          getExcludedMerchants?.pending,
          updateMerchantVisibility?.pending
        ),
        (state, action) => {
          if (action?.meta?.arg?.silent === true) return;
          state.loading = true;
        }
      )
      .addMatcher(
        isAnyOf(
          addBank?.rejected,
          createConnectedAccount?.rejected,
          createTransfer?.rejected,
          getBanks?.rejected,
          getFundraiserCategories?.rejected,
          getFundraisersBySubCategoryId?.rejected,
          getFundsDeposited?.rejected,
          getOnboardingStatus?.rejected,
          getWithdrawals?.rejected,
          getAccountDetails?.rejected,
          updateReferredBy?.rejected,
          getFundraisers?.rejected,
          getFundraiserInquiries?.rejected,
          addContent?.rejected,
          getFundraiserContent?.rejected,
          toggleFundraiserStatus?.rejected,
          getSubCategoriesByCategoryId?.rejected,
          referMerchant?.rejected,
          getFundraiserReferrals?.rejected,
          getDashboardStats?.rejected,
          getTransactions?.rejected,
          getMerchantById?.rejected,
          getTarget?.rejected,
          createTarget?.rejected,
          updateTarget?.rejected,
          getFundraiserById?.rejected,
          bulkStatusUpdate?.rejected,
          getAllTargets?.rejected,
          getAllMerchants?.rejected,
          getIncludedMerchants?.rejected,
          getExcludedMerchants?.rejected,
          updateMerchantVisibility?.rejected
        ),
        (state, action) => {
          state.loading = false;
          // Allow callers to silence error toasts
          // Check both meta.arg.silent and payload.silent
          if (action?.meta?.arg?.silent === true || action?.payload?.silent === true) {
            return;
          }
          const msg = action?.payload?.message || action?.error?.message || "Something went wrong";

          // COMMENTED OUT: Don't show "No users found for this fundraiser" as it's not an error
          // if (msg && msg.toLowerCase().includes('no users found')) {
          //   return;
          // }

          // Deduplicate toasts within a short window
          if (typeof window !== 'undefined') {
            const now = Date.now();
            const last = window.__LAST_ERROR_TOAST__ || { msg: null, at: 0 };
            if (last.msg !== msg || now - last.at > 4000) {
              toast.error(msg);
              window.__LAST_ERROR_TOAST__ = { msg, at: now };
            }
          } else {
            toast.error(msg);
          }
        }
      )
      .addMatcher(
        isAnyOf(
          getAllMerchants?.fulfilled,
          getIncludedMerchants?.fulfilled,
          getExcludedMerchants?.fulfilled,
          updateMerchantVisibility?.fulfilled
        ),
        (state) => {
          state.loading = false;
        }
      );
  },
});

export const { getSubscriptionData } = fundraiserSlice?.actions;
export default fundraiserSlice?.reducer;
